import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import NewsletterForm from "./NewsletterForm.js";
/* empty css                */
const Newsletter = ({
  alert,
  content,
  hideForm,
  title,
  ...newsletterFormProps
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: "newsletter__content-wrapper" }, title && /* @__PURE__ */ React.createElement(Heading, { variant: "small" }, title), alert, content, !hideForm ? /* @__PURE__ */ React.createElement(
    NewsletterForm,
    {
      key: newsletterFormProps.authEmail ? `auth-${newsletterFormProps.authEmail}` : "anon",
      ...newsletterFormProps
    }
  ) : null);
};
export {
  Newsletter
};
//# sourceMappingURL=Newsletter.js.map
